import { useQuery } from '@apollo/client';

import {
  GetArticleTotalsQuery,
  GetArticleTotalsQueryVariables,
} from '../../../../__generated__/graphql';
import GetArticleTotals from '../articleTotalsQuery.gql';

export const useGetArticleTotals = (variables: GetArticleTotalsQueryVariables) =>
  useQuery<GetArticleTotalsQuery, GetArticleTotalsQueryVariables>(GetArticleTotals, {
    variables,
  });
